import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { saveAs } from 'file-saver';

export default function initDownloadsPage(){
    if($('.marker-downloads-page').length < 1) return

    bindFilters();
	bindPagination();
	bindActions();
}

function getOccurrences(string, subString, allowOverlapping) {

    string += "";
    subString += "";

    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
    pos = 0,
    step = allowOverlapping ? 1 : subString.length;

    while (true) {

        pos = string.indexOf(subString, pos);
        if (pos >= 0) {
            ++n;
            pos += step;
        } else break;

    }

    return n;

}

function handleDownload() {

    let downloads		=	[];

    $('#downloads_results :checkbox:checked').each(function() {
        downloads.push( $(this).data('file') );
    });

    var zip		=	new JSZip();
    let count	=	0;

    downloads.forEach((download, index) => {

        const fileName	=	download.substring(download.lastIndexOf('/')+1);

        JSZipUtils.getBinaryContent(download, function (err, data) {

            zip.file(fileName, data, { binary: true });
            count++;

            if (count === downloads.length) {
                zip.generateAsync({ type: "blob" }).then(function (content) {
                    saveAs(content, "downloads.zip");
                });
            }

        });

    });

}

function bindFilters(){
	// FILTER TOGGLE
	$('.fn-toggle-download-filters').on('click', function() {
		$('.fn-download-filters').slideToggle();
		$('.fn-toggle-download-filters.filter-icon').toggleClass("d-none");
		$('.fn-toggle-download-filters.close-filter-icon').toggleClass("d-none");
	});

    // FILTER CHANGE
	document.addEventListener('change', function(e) {

		var id			=	e.target.getAttribute('id');

		if ( 'download_type' != id && 'download_area' != id  && 'download_category' != id && 'sort' != id ) return;

		e.preventDefault();
		e.target.blur();
		
		const $results	=	document.getElementById('downloads_results');
		const $type		=	document.getElementById('download_type');
		const $area		=	document.getElementById('download_area');
		const $category	=	document.getElementById('download_category');
		const $search	=	document.getElementById('document_search');
		const $sort 	= 	document.getElementById('sort');

		console.log('click');

		// ADD LOADING SPINNER
		// $results.classList.add('loading');

		let page_query	=	'pag=1';
		let srch_query	=	$search.value ? '&search=' + $search.value : '';
		//let type_query	=	$type.value > 0 ? '&type=' + $type.value : '';
		let area_query	=	$area.value > 0 ? '&area=' + $area.value : '';
		let cat_query	=	$category.value > 0 ? '&category=' + $category.value : '';
		let sort_query 	= 	$sort.value ? '&sort=' + $sort.value : 'DESC';

		// GET TOTAL RESULTS COUNT
		//fetch( config.templateDirUri + '/rest/downloads.php?count=1' + srch_query + type_query + area_query + cat_query + sort_query).then(function(response) {

		//	return response.text();

		//}).then(function(html) {

		//	document.getElementById('results_found').innerHTML = html;
			
		//});

		// GET RESULTS AND OUTPUT HERE
		fetch( config.templateDirUri + '/rest/downloads.php?' + page_query + srch_query + area_query + cat_query + sort_query).then(function(response) {

			return response.text();

		}).then(function(html) {
			
			$results.innerHTML = html;

			// UPDATE href
			let root		=	'//' + location.host + location.pathname;
			let page		=	'?pag=1';
			let search		=	( $search.value ? '&search=' + $search.value : '' )
			let type		=	( $type.value > 0 ? '&type=' + $type.value : '' );
			let area		=	( $area.value > 0 ? '&area=' + $area.value : '' );
			let category	=	( $category.value > 0 ? '&category=' + $category.value : '' );
			let sort 		= 	( $sort.value ? '&sort=' + $sort.value : 'DESC' );

			let newQuery		=	page + search + type + area + category + sort;
			const newURL		=	root + newQuery;

			if ( window.history.replaceState ) {

				window.history.pushState( null, 'Download Results', newURL );

			}

			// ADD LOADING SPINNER
			// $results.classList.remove('loading');
			backgroundImageLazyLoad();

		});

	}, false );
}

function bindPagination(){
    // PAGINATION
	$(document).on( 'click', '#pagination a', function(e) {

		e.preventDefault();
		e.target.blur();
		
		const $results	=	document.getElementById('downloads_results');
		const $area		=	document.getElementById('download_area');
		const $category	=	document.getElementById('download_category');
		const $sort 	= 	document.getElementById('sort');

		// ADD LOADING SPINNER
		// $results.classList.add('loading');

		var fullQuery	=	e.target.getAttribute('href').split('?');

		const urlParams = new URLSearchParams(fullQuery[1]);

		var pageN		=	'';

		if ( urlParams.get('pag') ) {

			pageN	=	urlParams.get('pag');

		} else {

			// NO QUERY STRING PRESENT
			pageN	=	1;

		}

		let page_query	=	'pag=' + pageN;
		let area_query	=	$area.value > 0 ? '&area=' + $area.value : '';
		let cat_query	=	$category.value > 0 ? '&category=' + $category.value : '';
		let srch_query	=	urlParams.get('search') ? '&search=' + urlParams.get('search') : '';
		let sort_query 	= 	$sort.value ? '&sort=' + $sort.value : 'DESC';

		// GET TOTAL RESULTS COUNT
		fetch( config.templateDirUri + '/rest/downloads.php?count=1' + srch_query + area_query + cat_query + sort_query).then(function(response) {

			return response.text();

		}).then(function(html) {

			document.getElementById('results_found').innerHTML = html;
			
		});

		// GET RESULTS AND OUTPUT HERE
		fetch( config.templateDirUri + '/rest/downloads.php?' + page_query + srch_query + area_query + cat_query + sort_query).then(function(response) {

			return response.text();

		}).then(function(html) {
			
			$results.innerHTML = html;

			const queryStr	=	window.location.search;
			const urlParams	=	new URLSearchParams(queryStr);

			// UPDATE href
			let root		=	'//' + location.host + location.pathname;
			let page		=	'?pag=' + pageN;
			let search		=	( urlParams.get('search') ? '&search=' + urlParams.get('search') : '' );
			let area		=	( $area.value > 0 ? '&area=' + $area.value : '' );
			let category	=	( $category.value > 0 ? '&category=' + $category.value : '' );
			let sort 		= 	( $sort.value ? '&sort=' + $sort.value: 'DESC' );

			let newQuery		=	page + search + area + category + sort;
			const newURL		=	root + newQuery;

			if ( window.history.replaceState ) {

				window.history.pushState( null, 'Download Results', newURL );

			}

			// REMOVE LOADING SPINNER
			// $results.classList.remove('loading');

		});

	});
}

function bindActions(){
    // TOGGLE ALL
	$('#select_all').on( 'click', function(e) {  

		if(this.checked) {
			$('.modular.download_centre :checkbox').each(function() {
				this.checked = true;                        
			});
		} else {
			$('.modular.download_centre :checkbox').each(function() {
				this.checked = false;                       
			});
		}

	});

	$(document).on( 'click', '#download_selected', function(e) {

		e.preventDefault();
		handleDownload();

	});
}